import { ApiUrls } from '@api/apiUrls';
import { fetchApi } from '@api/fetchApi';
import { IApiTradingPlatformType } from '@api/interfaces/data-contracts';
import { ILegalTradingPlatformsLink } from '@components-member/LegalTradings/shared/interfaces';
import { TRADING_PLATFORM_SECTION_TYPE } from 'global.enums';

export interface IApiUserTradingPlatformBrandingSettings {
  description: string;
  displayName: string;
  id: number;
  tradingPlatformType: IApiTradingPlatformType;
  imageUniqueId: string;
}

export const apiTradingPlatform = {
  getTradingPlatformBrandingSettings: async () => {
    return await fetchApi.get<IApiUserTradingPlatformBrandingSettings[]>(
      ApiUrls.tradingPlatformBrandingSettingsUser.getList,
    );
  },
  getLegalTradingPlatformUserList: async (params: { sectionType: TRADING_PLATFORM_SECTION_TYPE }) => {
    return await fetchApi.get<ILegalTradingPlatformsLink[]>(ApiUrls.legalTradingPlatformUser.list, {
      params,
    });
  },
};
